const DELETING_KEYS = ["Backspace", "Delete"];
const ENTER_KEY = "Enter";
const TAB_KEY = "Tab";
const ESCAPE_KEY = "Escape";
const SPACE_KEY = "Space";
const ARROW_UP_KEY = "ArrowUp";
const ARROW_DOWN_KEY = "ArrowDown";
const ARROW_LEFT_KEY = "ArrowLeft";
const ARROW_RIGHT_KEY = "ArrowRight";
const BACKSPACE_KEY = "Backspace";
const ACCEPTED_KEYS = [
  "Tab",
  "Enter",
  "Control",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  ...DELETING_KEYS,
];
const isNumberInput = (key) => Number.isInteger(Number(key));
const isDeletingInput = (key) => DELETING_KEYS.includes(key);
const isAllowedKey = (key) => ACCEPTED_KEYS.includes(key);
const isCopyEvent = ({ key, metaKey, ctrlKey, }) => key === "c" && (metaKey || ctrlKey);
const isPasteEvent = ({ key, metaKey, ctrlKey, }) => key === "v" && (metaKey || ctrlKey);
const isSelectAllEvent = ({ key, metaKey, ctrlKey, }) => key == "a" && (metaKey || ctrlKey);
const isAllowedInput = (event) => isNumberInput(event.key) ||
  isAllowedKey(event.key) ||
  isCopyEvent(event) ||
  isPasteEvent(event) ||
  isSelectAllEvent(event);
const isArrowDownInput = (key) => key === ARROW_DOWN_KEY;
const isArrowUpInput = (key) => key === ARROW_UP_KEY;
const isArrowLeftInput = (key) => key === ARROW_LEFT_KEY;
const isArrowRightInput = (key) => key === ARROW_RIGHT_KEY;
const isEnterInput = (key) => key === ENTER_KEY;
const isBackspaceInput = (key) => key === BACKSPACE_KEY;
const isSpaceInput = (code) => code === SPACE_KEY;
const isEscapeInput = (key) => key === ESCAPE_KEY;
const isTabInput = (key) => key === TAB_KEY;

export { ACCEPTED_KEYS as A, isAllowedInput as a, isNumberInput as b, isDeletingInput as c, isEscapeInput as d, isSpaceInput as e, isCopyEvent as f, isPasteEvent as g, isSelectAllEvent as h, isTabInput as i, isBackspaceInput as j, isEnterInput as k, isArrowRightInput as l, isArrowLeftInput as m, isArrowUpInput as n, isArrowDownInput as o };
